<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      temporary
    >
      <v-toolbar
        color="primary"
        dark
      >
        <v-img
          src="/img/HealthViewCapital-WhiteLogo.png"
          max-height="60"
          alt="HealthView Capital logo"
          contain
          @click="$router.push({path: '/'})"
        />
        <v-app-bar-nav-icon @click="drawer = !drawer">
          <v-icon>close</v-icon>
        </v-app-bar-nav-icon>
      </v-toolbar>
      <v-list>
        <template v-for="i in items">
          <v-list-item
            :key="i.title"
            :to="i.path"
            router
            exact
          >
            <v-list-item-action>
              <v-icon>{{ i.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title v-text="i.title" />
            </v-list-item-content>
          </v-list-item>
          <v-divider
            :key="`${i.title}-divider`"
            class="grey lighten-3"
          />
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      color="primary"
      dark
      elevate-on-scroll
    >
      <v-app-bar-nav-icon @click="drawer = !drawer" />
      <v-toolbar-items>
          <v-btn
          text
          to="/"
        >
          <img
            src="/img/HealthViewCapital-WhiteLogo.png"
            alt="HealthView Capital logo"
            style="max-width:12em"
          >
        </v-btn>
      </v-toolbar-items>
      <v-spacer />
      <v-toolbar-items v-if="$vuetify.breakpoint.mdAndUp">
      <v-btn
        text
        to="/management-team"
      >
        Management Team
      </v-btn>
      <v-btn
        text
        to="/overview"
      >
        Overview
      </v-btn>
      <v-btn
        text
        to="/contact"
      >
        Contact
      </v-btn>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: 'Navigation',
  data: () => ({
    drawer: false,
    offsettTop: 0,
    title: 'HealthView Capital',
    items: [
      {
        icon: 'people',
        title: 'Management Team',
        path: '/management-team',
        old_path: '/?page_id=21',
      },
      {
        icon: 'view_list',
        title: 'Overview',
        path: '/overview',
        old_path: '/?page_id=34',
      },
      {
        icon: 'chat',
        title: 'Contact',
        path: '/contact',
        old_path: '/?page_id=37',
      },
    ],
  }),
  methods: {},
}
</script>

<style lang="stylus" scoped>
.nav_logo {
  cursor: pointer;
}
</style>
